import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import TheFounders from "./sections/TheFounders";
import SystemintegrationPhilosophie from "./sections/SystemintegrationPhilosophie";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <TheFounders />
      <SystemintegrationPhilosophie />
      <Footer />
    </div>;
}